export const getUser = ({ User }) => User;

export const getProcessDefinitionKeys = (state) => getUser(state).processDefinitionKeys

export const getUserName = (state) => getUser(state).username

export const getUserSettings = (state) => getUser(state).settings;

export const getStatusItems = (state) => getUserSettings(state).statusItems;
